<template>
    <div class="logo-wrapper gap-3" :class="{foot: footer}">
        <a href="/ru/" title="На главную" class="logo" :class="{foot: footer}"></a>
        <div class="logo-slug" :class="{foot: footer}">Конкуренты во всех<br> красках</div>
    </div>
</template>

<script>
export default {
    props: {
        footer: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
        }
    },
}
</script>

<style scoped>
.logo-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 20px 0;
    order: 1;
}
.logo-wrapper.foot {
    justify-content: left;
    margin: 0 0 14px;
}
.logo {
    background: url(/i/blackSign.svg) no-repeat center;
    width: 170px;
    height: 50px;
    display: block;
}
.logo.foot {
    background: url("/i/icons/logo-light.svg") no-repeat center;
    width: 130px;
    background-size: contain;
}

.logo-slug {
    line-height: 1.2;
    font-size: 0.75rem;
}
.logo-slug.foot {
    color: white;
    text-align: left;
}

@media (max-width: 991px) {
    .logo.foot {
        width: 250px;
        height: 80px;
    }
    .logo-slug.foot {
        font-size: 18px;
        width: 250px;
    }
}
@media (max-width: 900px) {
    .logo-wrapper.foot {
        justify-content: center;
    }
}
@media (max-width: 768px) {
    .logo-wrapper.foot {
        margin-bottom: 26px;
    }
}
</style>

